import { render } from "./loader.vue?vue&type=template&id=b1c09d22&scoped=true"
const script = {}

import "./loader.vue?vue&type=style&index=0&id=b1c09d22&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1c09d22"]])

export default __exports__